import { HexaplaState } from '@/store/state'

export default {
  isLoggedIn: (state: HexaplaState) => state.user.isLoggedIn,
  getUser: (state: HexaplaState) => state.user,
  getContributor: (state: HexaplaState) => state.user.contributor,
  getFlash: (state: HexaplaState) => state.flashQueue,
  isLoadingResource: ({ loadingQueue }: HexaplaState) => loadingQueue.length,
}
